import React from "react";
import "./Loader.css";

const Loader: React.FC = () => {
  return (
    <div className="loader-backdrop">
      <div className="loader-spinner"></div>
    </div>
  );
};

export default Loader;
